"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function Discord(props) {
  return /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      fontFamily: 'Roboto',
      fontSize: '14px'
    }
  }, /*#__PURE__*/_react["default"].createElement("h3", {
    style: {
      fontWeight: 'bold',
      fontSize: 20
    }
  }, "Discuss on Discord"), /*#__PURE__*/_react["default"].createElement("p", null, "Join the MyGame Community on our Discord Channel"), /*#__PURE__*/_react["default"].createElement("span", {
    style: {
      display: 'block'
    }
  }, "Server Link: ", /*#__PURE__*/_react["default"].createElement("a", {
    target: "_blank",
    style: {
      color: 'black',
      textDecoration: 'underline',
      display: 'inline-block'
    },
    href: "https://discord.gg/RBwHjWz"
  }, "https://discord.gg/RBwHjWz")), /*#__PURE__*/_react["default"].createElement("a", {
    href: "https://discord.gg/RBwHjWz",
    target: "_blank",
    style: {
      fontWeight: 'bold',
      padding: '6px 12px',
      backgroundColor: '#e8490d',
      border: "none",
      borderRadius: '5px',
      marginTop: '15px',
      color: 'white',
      fontSize: '12px',
      display: 'inline-block'
    }
  }, "OPEN"));
}
var _default = Discord;
exports["default"] = _default;


/*****************
 ** WEBPACK FOOTER
 ** ./~/mygame-components/dist/ReportCards/Discord.js
 ** module id = 2385
 ** module chunks = 0
 **/